import { useTheme } from '@mui/material';
import { Box, Typography, ButtonGroup } from '@mui/material';
import { useIntl } from 'react-intl';

import { GROUP_BY_OPTIONS } from '@verantos-dev/core-annotation-tool';
import { getTabStyle } from '@verantos-dev/core-annotation-tool';
import { Button } from '@verantos-dev/shared-components';

import { useGroupBySection } from './useGroupBySection';

export const GroupBySection = () => {
  const theme = useTheme();
  const { groupBy, handleGroupByChange } = useGroupBySection();

  const { formatMessage } = useIntl();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: theme.spacing(2) }}>
      <Typography variant="body1" sx={{ fontWeight: '500' }}>
        {formatMessage({ id: 'workspaceCommon.sidebar.viewOptions.groupBy.title' })}
      </Typography>
      <ButtonGroup
        color="inherit"
        orientation="horizontal"
        variant="contained"
        sx={{ width: '100%', borderRadius: 0 }}
      >
        {GROUP_BY_OPTIONS.map((option: string) => (
          <Button
            key={option}
            id={option}
            displayLabel={formatMessage({
              id: `workspaceCommon.sidebar.viewOptions.groupBy.${option}`,
            })}
            sx={getTabStyle(option, groupBy, theme)}
            onClickHandler={() => handleGroupByChange(option)}
          />
        ))}
      </ButtonGroup>
    </Box>
  );
};
